import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../shared/auth.service';
import {ClientApiService} from '../client-api.service';
import {AnalyticsService} from '../../shared/analytics.service';
import {ModalComponent} from '../../shared/modal/modal.component';
import {AppStateService} from '../../shared/app-state.service';
import {normalizePhone} from '../../../utils';

@Component({
  selector: 'contact-agent',
  templateUrl: './contact-agent.component.html',
  styleUrls: ['./contact-agent.component.scss'],
  // FIXME migrate to OnPush (eliminate ChangeDetectorRef usages)
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactAgentComponent implements OnInit {

  @ViewChild('contactModal') contactModal: ModalComponent;

  @Input() staff: StaffInfo[];
  @Input() orderId: string;
  @Input() small = false;

  agent: StaffInfo;
  director: StaffInfo;
  messageText: string | null = null;
  messageSubmitting = false;
  messageSubmitted = false;
  email: string | null = null;
  submitError = false;
  masquerading$ = this.Auth.masquerading$;

  constructor(private Api: ClientApiService,
              private Auth: AuthService,
              private Analytics: AnalyticsService,
              private AppState: AppStateService,
              private Changes: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (this.staff) {
      for (const staff of this.staff) {
        if (staff.agent) {
          this.agent = {
            ...staff,
            phone: normalizePhone(staff.phone)
          };
        } else {
          this.director = {
            ...staff,
            phone: normalizePhone(staff.phone)
          };
        }
      }
    }
  }

  resetForm(): void {
    this.messageSubmitted = false;
    this.messageSubmitting = false;
  }

  closeContactModal(): void {
    this.resetForm();
    this.contactModal.hide();
    this.messageText = null;
    this.email = null;
  }

  sendMessage(): void {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.messageSubmitting = true;
    this.Api.sendEmail(this.messageText, this.orderId, this.email || undefined)
      .subscribe(() => {
        this.messageSubmitted = true;
        this.messageSubmitting = false;
        this.Analytics.trackEvent('Email sent', {category: 'Action'});
        this.Changes.detectChanges();
      }, () => {
        this.submitError = true;
        this.messageSubmitting = false;
        this.Changes.detectChanges();
      });
  }

  isValid() {
    return this.messageText !== null && (this.Auth.isFullyAuthenticated() || this.email !== null);
  }

  getLoggedIn() {
    return this.Auth.isFullyAuthenticated();
  }

  isCheckMarkOrange() {
    const brand: string = this.AppState.brand$.getValue();
    return (brand === 'aq' || brand === 'co');
  }
}
